export function resolveCountConfig(count, showCount) {
    if (count) {
        return count;
    }
    if (showCount) {
        if (typeof showCount === 'object' && showCount) {
            return {
                show: (info) => showCount.formatter({
                    count: info.count,
                    maxlength: info.maxLength,
                    value: info.value,
                }),
            };
        }
        return { show: true };
    }
    return false;
}
export function getCountLength(value, strategy) {
    if (strategy) {
        return strategy(value);
    }
    return [...value].length;
}
export function formatCountDisplay(config, value, count, maxLength) {
    const { show, max } = config;
    if (typeof show === 'function') {
        return show({ value, count, maxLength: maxLength !== null && maxLength !== void 0 ? maxLength : max });
    }
    const limit = maxLength !== null && maxLength !== void 0 ? maxLength : max;
    return `${count}${limit != null ? ` / ${limit}` : ''}`;
}
